import gql from "graphql-tag";
export const withdrawalsData = gql`
  query withdrawalsData($orderBy: OrderBy, $filters: Filter, $page: Int, $perPage: Int) {
    withdrawals(orderBy: $orderBy, filters: $filters, page: $page, first: $perPage) {
      paginatorInfo {
        total
        perPage
        currentPage
        lastPage
      }

      data {
        id
        amount
        comment
        status
        createdAt
        user {
          id
          firstName
          lastName
        }
      }
    }
  }
`;

export const transactionsData = gql`
  query transactionsData($orderBy: OrderBy, $filters: Filter, $page: Int, $perPage: Int) {
    transactions(orderBy: $orderBy, filters: $filters, page: $page, first: $perPage) {
      paginatorInfo {
        total
        perPage
        currentPage
        lastPage
      }

      data {
        id
        type
        amount
        comment
        createdAt
        referral {
          id
          name
          user {
            id
            firstName
            lastName
          }
        }
        user {
          id
          firstName
          lastName
        }
        withdrawal {
          id
          amount
          user {
            id
            firstName
            lastName
          }
        }
      }
    }
  }
`;
